import React from 'react';
import { GovEmpty, GovIcon } from '@gov-design-system-ce/react';
import cx from 'classnames';

export interface InfoBannerProps {
	headline?: string;
	text?: string | React.ReactNode;
	className?: string;
	orientation?: 'horizontal' | 'vertical';
	variant?: 'default' | 'error';
}

export const InfoBanner = ({
	headline,
	text,
	className,
	orientation,
	variant = 'default',
}: InfoBannerProps) => (
	<GovEmpty
		icon={
			<GovIcon
				name={variant === 'error' ? 'error' : 'empty-file'}
				type="colored"
				slot="icon"
			/>
		}
		headline={
			headline ? (
				<p
					slot="headline"
					className={cx(
						'wrap-anywhere hyphens-auto',
						orientation === 'horizontal' ? undefined : 'text-center'
					)}>
					{headline}
				</p>
			) : undefined
		}
		align={orientation === 'horizontal' ? 'left' : 'center'}
		direction={orientation === 'horizontal' ? 'horizontal' : 'vertical'}
		size={orientation === 'horizontal' ? 's' : 'l'}
		className={className}>
		{text ? (
			orientation === 'horizontal' ? (
				<p>{text}</p>
			) : (
				<p className="text-center">{text}</p>
			)
		) : null}
	</GovEmpty>
);
